<div id="driversessions_info" class="tablewrap resizetable tabpage hidden">
  <div class="table">
    <div class="blockheader">{{'Loading'|translate }}</div>
    <table fixedcols="[]" id="driversessionstable">
      <tr>
        <th class="object_column">{{'Driver'|translate }}</th>
        <th class="object_column">{{'Object'|translate }}</th>
        <th class="time_column">{{'Start'|translate }}</th>
        <th class="time_column">{{'Finish'|translate }}</th>
        <th class="mileage_column">{{'Mileage'|translate }}</th>
        <th class="time_column">{{'Engine time'|translate }}</th>
        <th>{{'Fuel consumption'|translate }}</th>
        <th>{{'Penalty'|translate }}</th>
        <th>{{'Violations'|translate }}</th>
      </tr>
    </table>
  </div>
    <app-pagination [viewmode]="'print excel pages'" [printElementID]="'driversessionstable'"></app-pagination>
</div>
